import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'icono_red'
})
export class IconoRedPipe implements PipeTransform {
  transform(value: any) {


    if( value == 0 || value == undefined){
      return 2;
    }else{
      let time = new Date().valueOf();
      let res = time - value;
      //console.log(res);
      if( res >= 3000 ){
        return 0;
      }else{
        return 1;
      }
    }


  }
}



// WEBPACK FOOTER //
// C:/xampp/htdocs/service_tracking/web/service_tracking/src/app/pipes/iconConectado.pipe.ts